import { useEffect, useState } from 'react'
import DashboardBox from './DashboardBox'
import { CustomerAnalysis } from '../GeneratedClients/FreeBillApi'
import { apiService } from '../apiService'
import CustomersTable from './CustomersTable'
import { HubConnection } from '@microsoft/signalr'
import DashboardSlider from './DashboardSlider'
import { customerAnalysisFakeData } from './noContentFakeData'
import { useTranslate } from 'react-admin'

interface IProps {
  connection?: HubConnection
}

const Customers = ({connection}: IProps) => {

  const [ customerAnalysis, setCustomerAnalysis ] = useState<CustomerAnalysis[]>([])
  const [ totalCustomers, setTotalCustomers ] = useState<number>(5)
  const [ noContent, setNoContent] = useState<boolean>(false)
  const [ refresh, setRefresh] = useState<boolean>(true)
  const translate = useTranslate()

  const fetchData = async() => {
    var { data: customerAnalysis } = await apiService.CustomersApi.getCustomerAnalysisList()
    customerAnalysis.length === 0 && setNoContent(true)
    setCustomerAnalysis(customerAnalysis.length === 0 ? customerAnalysisFakeData() : customerAnalysis)
  }

  connection?.on('InvoiceUpdated', (invoice) => {
    setRefresh(!refresh)
  })

  useEffect(() => {
    fetchData()
  }, [refresh])

  return (
    <DashboardBox 
      title={translate("resources.dashboard.customers.title", {smart_count: totalCustomers})}
      slider={
        <DashboardSlider 
          label='Kunden:'
          min={5}
          max={10}
          step={1}
          value={totalCustomers}
          setValue={setTotalCustomers} 
        />
      }
      minWidth={"47%"}
      noContent={noContent ? translate("resources.dashboard.customers.noContent") : undefined}
      content={[<CustomersTable customerAnalysis={customerAnalysis} totalCustomers={totalCustomers} key={1}/>]}
    />
  )
}

export default Customers